<div class="card p-2 p-md-4 rounded-4 thick-border-gray shadow-none mt-2">
  <!-- Header Section -->
  <div class="d-flex justify-content-between align-items-center gap-2 mb-3">
    <p class="heading-text fw-bold m-0">Dealers who stopped buying</p>
    @if (dealers.length) {
      <button class="btn export-btn" (click)="exportCSV()">
        Export
      </button>
    }
  </div>

  <!-- Loader State -->
  @if (loader) {
    <div class="d-flex justify-content-center py-5">
      <app-loader [loadingIcon]="loader"></app-loader>
    </div>
  }

  <!-- Error State -->
  @if (!loader && errorMessage) {
    <div class="text-center py-4">
      <p class="text-danger mb-0 small fw-bold">{{ errorMessage }}</p>
    </div>
  }

  <!-- Content State -->
  @if (!loader && dealers.length > 0) {
    <div class="table-responsive table-container">
      <table class="table custom-table align-middle m-0">
        <thead>
          <tr>
            <th>Dealer name</th>
            <th>Last quantity</th>
            <th>Last purchase price</th>
            <th>Last purchase date</th>
            <th>Days since last buy</th>
          </tr>
        </thead>
        <tbody>
          @for (dealer of displayedDealers; track dealer) {
            <tr>
              <td>{{ dealer.dealerName }}</td>
              <td>{{ dealer.quantity }}</td>
              <td>₹{{ dealer.unitPrice | number }}</td>
              <td>{{ dealer.date }}</td>
              <td [ngClass]="dealer.daysSinceLastBuy > 100 ? 'red-color' : 'orange-color'">
                {{ dealer.daysSinceLastBuy }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <!-- Footer Section -->
    @if (dealers.length > limit) {
      <div class="footer-section row d-flex justify-content-between align-items-center mt-3 pt-2"
        >
        <div class="col-8">
          <p class="footer-text text-muted m-0">
            {{ limit }} of {{ dealers.length }} dealers on this screen. View more for the full list.
          </p>
        </div>
        <div class="col-4 d-flex align-items-center justify-content-end">
          <button class="btn btn-view-more d-flex align-items-center gap-2 py-2 px-3" (click)="viewMore(dealerModal)">
            <span class="small fw-bold">View More</span>
            <fa-icon [icon]="faAngleRight" size="sm"></fa-icon>
          </button>
        </div>
      </div>
    }
  }
</div>

<!-- Modal Template -->
<ng-template #dealerModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="fw-bold mb-0 heading-text">Dealers who stopped buying</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body p-2 p-md-4">
    <div class="table-responsive table-container">
      <table class="table custom-table align-middle m-0">
        <thead>
          <tr>
            <th>Dealer name</th>
            <th>Last quantity</th>
            <th>Last purchase price</th>
            <th>Last purchase date</th>
            <th>Days since last buy</th>
          </tr>
        </thead>
        <tbody>
          @for (dealer of dealers; track dealer) {
            <tr>
              <td>{{ dealer.dealerName }}</td>
              <td>{{ dealer.quantity }}</td>
              <td>₹{{ dealer.unitPrice | number }}</td>
              <td>{{ dealer.date }}</td>
              <td [ngClass]="dealer.daysSinceLastBuy > 100 ? 'red-color' : 'orange-color'">
                {{ dealer.daysSinceLastBuy }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>